import React from "react";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import PendingOutlinedIcon from "@mui/icons-material/PendingOutlined";
import ErrorOutlinedIcon from "@mui/icons-material/ErrorOutlined";
import ChangeCircleOutlinedIcon from "@mui/icons-material/ChangeCircleOutlined";

import { formStatusMessage } from "./AppraisalFunctions";

import { Tooltip } from "@mui/material";

const AppraisalFormStatusIcon = ({
    status,
    form = null,
    isAppraiser = false,
}) => {
    const title = form ? form.charAt(0).toUpperCase() + form.slice(1) : "";
    const message = formStatusMessage(form, status, isAppraiser);

    const statusIcons = {
        completed: <CheckCircleOutlineOutlinedIcon color={message.severity} />,
        rejected_2: <InfoOutlinedIcon color={message.severity} />,
        rejected_1: <InfoOutlinedIcon color={message.severity} />,
        rejected: <InfoOutlinedIcon color={message.severity} />,
        awaiting_approval_2: <InfoOutlinedIcon color={message.severity} />,
        awaiting_approval_1: <InfoOutlinedIcon color={message.severity} />,
        awaiting_approval: <InfoOutlinedIcon color={message.severity} />,
        review: <ChangeCircleOutlinedIcon color={"info"} />,
        incomplete: <PendingOutlinedIcon color={message.severity} />,
        escalated: <ErrorOutlinedIcon color={"error"} />,
        error: <ErrorOutlineOutlinedIcon color={"error"} />,
    };

    const icon = statusIcons[status] || (
        <RadioButtonUncheckedIcon color={"disabled"} />
    );

    return (
        <Tooltip title={title} placement="top" arrow>
            {icon}
        </Tooltip>
    );
};

export default React.memo(AppraisalFormStatusIcon);
